(function () {
  function init(section) {
    if (section.dataset.mpv4Initialized === 'true') return;
    section.dataset.mpv4Initialized = 'true';
    const slides = [...section.querySelectorAll('[data-mpv4-slide]')];
    const thumbs = [...section.querySelectorAll('[data-mpv4-thumb]')];
    const count = section.querySelector('[data-mpv4-current]');
    let active = 0;
    function show(index) {
      if (!slides.length) return;
      active = (index + slides.length) % slides.length;
      slides.forEach((item, i) => { item.hidden = i !== active; });
      thumbs.forEach((item, i) => {
        const selected = i === active;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-pressed', String(selected));
      });
      if (count) count.textContent = String(active + 1).padStart(2, '0');
      if (thumbs[active]) thumbs[active].scrollIntoView({block:'nearest', inline:'nearest', behavior:'auto'});
    }
    section.querySelector('[data-mpv4-prev]')?.addEventListener('click', () => show(active - 1));
    section.querySelector('[data-mpv4-next]')?.addEventListener('click', () => show(active + 1));
    thumbs.forEach((node, i) => node.addEventListener('click', () => show(i)));
    const qty = section.querySelector('[data-mpv4-quantity]');
    section.querySelector('[data-mpv4-minus]')?.addEventListener('click', () => { if (qty) qty.value = String(Math.max(1, (parseInt(qty.value,10)||1)-1)); });
    section.querySelector('[data-mpv4-plus]')?.addEventListener('click', () => { if (qty) qty.value = String((parseInt(qty.value,10)||1)+1); });
    section.querySelector('[data-mpv4-variants]')?.addEventListener('change', event => {
      const chosen = event.target.selectedOptions[0];
      const price = section.querySelector('[data-mpv4-price]');
      if (price && chosen?.dataset.mpv4Price) price.textContent = chosen.dataset.mpv4Price;
    });

    const form = section.querySelector('.mpv4-product-form');
    let adding = false;
    if (section.dataset.mpv6AppNative !== 'true') form?.addEventListener('submit', async event => {
      const drawer = document.querySelector('theme-drawer#cart-drawer');
      if (!drawer) return;
      event.preventDefault();
      if (adding || !form.reportValidity()) return;
      const button = form.querySelector('button[type="submit"]');
      if (button?.disabled) return;
      const label = form.querySelector('[data-mpv4-carttext]');
      const status = form.querySelector('[data-mpv4-formstatus]');
      const originalLabel = label?.textContent;
      const data = new FormData(form);
      const sectionIds = [...new Set([...document.querySelectorAll('cart-items-component')].map(item => item.dataset.sectionId).filter(Boolean))].slice(0,5);
      data.set('sections', sectionIds.join(','));
      data.set('sections_url', window.location.pathname);
      adding = true;
      let added = false;
      if (button) { button.disabled = true; button.setAttribute('aria-busy','true'); }
      if (label) label.textContent = 'Adding…';
      if (status) status.textContent = '';
      try {
        const { CartLinesUpdateEvent } = await import('@shopify/events');
        await Promise.all([customElements.whenDefined('theme-drawer'), customElements.whenDefined('cart-items-component')]);
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'cart/add.js', {method:'POST', body:data, headers:{Accept:'application/json'}, credentials:'same-origin'});
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || 'Unable to add this item. Please try again.');
        added = true;
        const cartResponse = await fetch(root + 'cart.js', {headers:{Accept:'application/json'},credentials:'same-origin'});
        if (!cartResponse.ok) throw new Error('The item was added, but the cart could not refresh. Please open your cart to check it.');
        const cart = await cartResponse.json();
        const update = Promise.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: {items:cart.items, itemCount:cart.item_count, sections:result.sections, source:'mp-product-form', sourceId:form.id, didError:false}
        });
        form.dispatchEvent(new CartLinesUpdateEvent({
          action:'add', context:'product',
          lines:[{merchandiseId:String(data.get('id')),quantity:Number(data.get('quantity')) || 1}],
          promise:update
        }));
        drawer.open();
        if (status) status.textContent = 'Added to your cart.';
      } catch (error) {
        if (status) status.textContent = added ? 'Your item was added. Please open the cart to check it before adding again.' : (error.message || 'Unable to add this item. Please try again.');
      } finally {
        adding = false;
        if (button) { button.disabled = false; button.removeAttribute('aria-busy'); }
        if (label) label.textContent = originalLabel;
      }
    });

    const radios = section.querySelectorAll('[data-mpv4-once],[data-mpv4-repeat]');
    const planBox = section.querySelector('[data-mpv4-planbox]');
    const planSelect = planBox?.querySelector('select');
    radios.forEach(radio => radio.addEventListener('change', () => {
      const isRepeat = section.querySelector('[data-mpv4-repeat]')?.checked || false;
      if (planBox) planBox.hidden = !isRepeat;
      if (planSelect) planSelect.disabled = !isRepeat;
      section.querySelectorAll('.mpv4-option').forEach(option => option.classList.toggle('is-active', option.querySelector('input')?.checked));
    }));
    section.querySelector('[data-mpv4-scroll]')?.addEventListener('click', () => {
      const target = section.querySelector('.mpv4-buy');
      target?.scrollIntoView({behavior:'smooth', block:'start'});
      window.setTimeout(() => section.querySelector('.mpv4-add')?.focus({preventScroll:true}), 300);
    });
  }
  function ready() { document.querySelectorAll('.mpv4').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();
  document.addEventListener('shopify:section:load', ready);
})();
